import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './services/ServiceWorkerService';

import './global.css';

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js